export default [
  {
    title: 'sandoz.apo_one_contracts',
    icon:'file-signature',
    requiredPermissions: [
      'GET api/sandoz/apo-one/contracts'
    ],
    target: 'sandoz.apo_one.contracts'
  },
  {
    title: 'core.apo_one_addresses',
    icon: 'table',
    requiredPermissions: [
      'POST api/system/apo_one_addresses/{id}',
      'DELETE api/system/apo_one_addresses/{id}'
    ],
    target: 'system.apo_one_address_list'
  },
  /*Disable for now
  {
    title: 'core.apo_one_users',
    icon: 'users',
    requiredPermissions: [
      'POST api/system/apo_one_users/{id}',
      'DELETE api/system/apo_one_users/{id}'
    ],
    target: 'system.apo_one_user_list'
  }*/
]
